import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import styles from './tabs.scss';

// Because this component is iterating over its children only to add
// classNames to the props, the idx as key as acceptable.
/* eslint-disable  react/no-array-index-key */
const Tabs = ({
  children,
}) => (0 < children.length &&
<nav className={styles.tabs}>
  {children.map((child, idx) => (
    React.cloneElement(
      child,
      {
        className: classNames(child.className, styles.tab),
        activeClassName: styles.active,
        key: idx,
      })
  ))}
</nav>
);

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Tabs;



// WEBPACK FOOTER //
// ./app/components/tabs/index.js